export const senecButtonTheme = {
    defaultProps: {
        disableRipple: true,
        disableElevation: true,
    },
};
